import React, { useEffect } from 'react'
import { StepsStyle, Step } from './style'
import { useSelector } from 'react-redux'
import { SS } from 'utils/common'
import { FormattedMessage } from 'react-intl'

/**
 * getStepName {Function}
 * @description - get an appropriate step's name
 * @return {String}
 * */
const getStepName = (name) => {
	let nameVariant

	switch (name) {
		case 'SELECT':
			nameVariant = 'selection'
			break
		case 'RETURN':
			nameVariant = 'refund'
			break
		case 'REFUND':
			nameVariant = 'repayment'
			break
		case 'COMPLAINT':
			nameVariant = 'reclamation'
			break
		default:
			nameVariant = name
			break
	}

	return nameVariant.toLowerCase()
}

const Steps = () => {
	const state = useSelector((state) => state.steps)
	useEffect(() => {
		SS.set('steps', state)
	}, [state])
	return (
		<>
			<StepsStyle>
				{state.steps?.map((step, idx) => {
					return (
						<Step
							key={idx}
							data-step={idx + 1}
							status={step.status}
							isSingle={state.steps.length === 1}
						>
							<FormattedMessage
								id={`progress.bar.${getStepName(step.name)}`}
								defaultMessage={step.name}
							/>
						</Step>
					)
				})}
			</StepsStyle>
		</>
	)
}
export default Steps
